module.exports = __webpack_public_path__ + "img/career-poly.d783d847.svg";